import React from "react";
import { isMobile } from "react-device-detect";
import EmlAthnModalUi from "Utils/EmlAthnModalUi";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnUi from "Utils/MbpAthn";
import MgpStore from "Stores/Store";
import MembOtpRegScrtApi from "Apis/MembOtpRegScrtApi";
import { Helmet } from "react-helmet-async";
import MembOtpUnRegApi from "Apis/MembOtpUnRegApi";
import ApiResultModal from "Components/ApiResultModal";


const MembOtpRegUi = () => {
    const langData:any = useOutletContext();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [otpRegYn,setotpRegYn] = useState<any>();
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) {
            action();
        }
    };
    const [emlAthnPrpsCd] = useState("OTP_UNREG_MYPAGE");
    const [currentAthnPrpsCd, setCurrentAthnPrpsCd] = useState<string>(""); // 현재 인증 목적 추가
    const [showEmlModal, setShowEmlModal] = useState(false);
        var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
        var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
        const EmlAthnPopFunc = (athnPrpsCd: string)=>{
            setCurrentAthnPrpsCd(athnPrpsCd); // 인증 목적 설정
            if (isMobile) {
                setShowEmlModal(true);
            } else {
                const url = `/EmlAthnPop?emlAthnPrpsCd=${athnPrpsCd}&lang=${MgpStore.getState().LangSetState.Lang}`;
                window.open(url,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
            }
        }
    useEffect(()=>{
        
        MembOtpRegChkApi()
        .then((resp) => {
            setotpRegYn(resp.apiBody);
        })
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                switch(resp.apiHdr.code) {
                    case "ATHN0000":

                        if(resp.apiBody.athnPrpsCd == "OTP_REG"){
                            MembOtpRegScrtApi()
                            .then((resp) => {
                                navigate("/MyPage/otpRegInput",{state:{otpScrt:resp.apiBody.otpScrt,qrCdImg:resp.apiBody.qrCdImg}});
                            });
                        }else if(resp.apiBody.athnPrpsCd == "OTP_UNREG_MYPAGE"){
                        MembOtpUnRegApi().then((resq)=>{
                            if(resq.apiHdr.code == "MEMB0000") {
                                openResultModal(
                                    langData&&langData.MYPAGE_OTP_ATHN_UNREG_DESC_00,
                                    () => navigate("/mypage")
                                );
                            }
                        });
                        }
                        break;
                    case "ATHN2312":
                        openResultModal(langData&&langData.GLB_ATHN_FAIL_LBL_00);
                        return;
                    default:
                        openResultModal((langData&&langData.GLB_ATHN_FAIL_DESC_00) + resp.apiHdr.code);
                        return;
                }
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        const emlAthnRespFunc =() => {
            // 현재 설정된 athnPrpsCd에 따라 분기 처리
            if(currentAthnPrpsCd === "OTP_REG") {
                return MembOtpRegScrtApi()
                        .then((resp) => {
                            navigate("/MyPage/otpRegInput",{state:{otpScrt:resp.apiBody.otpScrt,qrCdImg:resp.apiBody.qrCdImg}});
                        });
            } else if(currentAthnPrpsCd === "OTP_UNREG_MYPAGE") {
                return MembOtpUnRegApi().then((resp)=>{
                    if(resp.apiHdr.code == "MEMB0000") {
                        openResultModal(
                            langData&&langData.MYPAGE_OTP_ATHN_UNREG_DESC_00,
                            () => navigate("/mypage")
                        );
                    }
                });
            }
        }
        window.emlAthnRespFunc = emlAthnRespFunc;
    },[MgpStore.getState().LangSetState.Lang, currentAthnPrpsCd]); // currentAthnPrpsCd 의존성 추가
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="myPageSubCtxtWrap">
                <img className="otpImg" src={process.env.PUBLIC_URL+"/images/Mypage/OtpIcon.png"} alt="" />
                {/* otp 사용 여부 */}
                <div className="otpTxtWrap">
                    {otpRegYn&&otpRegYn.otpUseYn =="Y"?
                        <>
                            <p className="myPageCtxtTitl myPageEmlChngTitl">{langData&&langData.MYPAGE_OTP_UNREG_PAGE_TITL_00}</p>
                            <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_OTP_UNREG_PAGE_DESC_00}</p>                            
                            <div className="myPageEmlChngMbpAthn">
                                {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "MBP"?
                                    <MbpAthnUi  athnPrpsCd='OTP_UNREG_MYPAGE'AthnTxt={langData&&langData.MYPAGE_MAIN_OTP_UNREG_BTN_00}/>
                                    :
                                    <>
                                    <button onClick={() => EmlAthnPopFunc("OTP_UNREG_MYPAGE")}> 
                                        <span>{langData&&langData.MYPAGE_MAIN_OTP_UNREG_BTN_00}</span>
                                        {/* 인증하기 */}
                                    </button>
                                    {showEmlModal && (
                                        <EmlAthnModalUi
                                            emlAthnPrpsCd={"OTP_UNREG_MYPAGE"}
                                            onSuccess={(athnPrpsCd: string) => {
                                                setShowEmlModal(false);
                                                if (typeof window.emlAthnRespFunc === 'function') {
                                                    window.emlAthnRespFunc(athnPrpsCd);
                                                }
                                            }}
                                            onClose={() => setShowEmlModal(false)}
                                        />
                                    )}
                                    </>
                                }
                            </div>
                        </>
                        // otp 사용중
                        :
                        <>
                            <p className="myPageCtxtTitl myPageEmlChngTitl">{langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}</p>
                            <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_OTP_REG_PAGE_TITL_00}</p>
                            <div className="myPageEmlChngMbpAthn">
                                {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "MBP"?
                                    <MbpAthnUi  athnPrpsCd='OTP_REG'AthnTxt={langData&&langData.MYPAGE_MAIN_OTP_REG_BTN_00}/>
                                    :
                                    <>
                                    <button onClick={() => EmlAthnPopFunc("OTP_REG")}> 
                                        <span>{langData&&langData.MYPAGE_MAIN_OTP_REG_BTN_00}</span>
                                        {/* 인증하기 */}
                                    </button>
                                    {showEmlModal && (
                                        <EmlAthnModalUi
                                            emlAthnPrpsCd={"OTP_REG"}
                                            onSuccess={(athnPrpsCd: string) => {
                                                setShowEmlModal(false);
                                                if (typeof window.emlAthnRespFunc === 'function') {
                                                    window.emlAthnRespFunc(athnPrpsCd);
                                                }
                                            }}
                                            onClose={() => setShowEmlModal(false)}
                                        />
                                    )}
                                    </>
                                }
                            </div>
                        </>
                    }
                </div>
            </div> 
        </div>
        </>
    )
}

export default MembOtpRegUi;